
export const CatActionTypes = {
  SET_EXISTING_CATEGORIES: 'SET_EXISTING_CATEGORIES'
};